import React from 'react';

const SpinnerOverlay = () => {
  return (
    <>
      <style>{`
        .spinner-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(68, 70, 70, 0.47);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          z-index: 10;
        }

        #title {
          font-size: 25px;
          font-weight: bold;
          text-align: center;
          color: #fff;
          margin-bottom: 20px;
        }

        .spinner {
          display: flex;
          gap: 0.5rem;
          width: fit-content;
          height: 100px;
        }

        .spinner > div {
          background-color: #333;
          height: 100%;
          width: 7px;
          animation: stretchdelay 1.2s infinite ease-in-out;
        }

        .spinner .rect2 { animation-delay: -1.1s; }
        .spinner .rect3 { animation-delay: -1.0s; }
        .spinner .rect4 { animation-delay: -0.9s; }
        .spinner .rect5 { animation-delay: -0.8s; }

        @keyframes stretchdelay {
          0%, 40%, 100% { transform: scaleY(0.4); }
          20% { transform: scaleY(1.0); }
        }
      `}</style>

      <div className="spinner-overlay">
        {/* <div id="title">Loading Spinner</div> */}
        <div className="spinner">
          <div className="rect1"></div>
          <div className="rect2"></div>
          <div className="rect3"></div>
          <div className="rect4"></div>
          <div className="rect5"></div>
        </div>
      </div>
    </>
  );
};

export default SpinnerOverlay;
